module.exports = __webpack_public_path__ + "static/media/cartoes_hipercard.8af4277d.svg";